"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitle = exports.StyledHeader = exports.StyledExpansionItem = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledExpansionItem = styled_components_1.default.div `
  border: 1px solid ${ui_components_1.baseColors.background100};
`;
exports.StyledHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.82rem 0.63rem;

  background-color: ${ui_components_1.baseColors.white};

  cursor: pointer;
`;
exports.StyledTitle = styled_components_1.default.span `
  font-size: 0.875rem;
`;
